import Marquee from "react-fast-marquee";

const WORDS = ["Website-Service", "Domain inklusive", "Hosting inklusive", "Betreuung", "Alles aus einer Hand", "Monatlich flexibel", "Ohne hohe Anfangskosten"];

export default function Ticker() {
  return (
    <section className="border-y border-white/10 bg-[#050505] py-5" data-testid="ticker">
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display uppercase text-3xl md:text-5xl tracking-tight text-neutral-700 mx-8">
              {w}
            </span>
            <span className="text-[#FF3B00] text-2xl">✳</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
